<template>
  <v-sheet>
    <v-container class="py-8 mb-8">
      <v-row>
        <v-col cols="12" md="6">
          <h1 class="black--text">{{ $t('contactUs.title') }}</h1>
          <div class="font-weight-bold text-body-1">
            <div class="d-flex align-center mt-3">
              <v-icon color="secondary">mdi-map-marker-outline</v-icon>
              <span class="ml-1">
                {{ $t('contactUs.adress') }}
              </span>
            </div>
            <div class="d-flex align-center mt-3">
              <v-icon color="secondary">mdi-phone-outline</v-icon>
              <span class="ml-1">
                <a
                  href="https://api.whatsapp.com/send?phone=5531997076411&text=Olá,%20Antônio.%20Me%20conte%20mais%20sobre%20as%20soluções%20da%20Criptonomia."
                  class="text-decoration-none"
                  style="color: #222222"
                >
                  {{ $t('contactUs.number') }}
                </a>
              </span>
            </div>
            <div class="d-flex align-center mt-3">
              <v-icon color="secondary">mdi-email-outline</v-icon>
              <span class="ml-1">
                {{ $t('contactUs.email') }}
              </span>
            </div>
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="secondary"
              class="ma-2 white--text"
              @click="
                openNewTab(
                  'https://api.whatsapp.com/send?phone=5531997076411&text=Olá,%20Antônio.%20Me%20conte%20mais%20sobre%20as%20soluções%20da%20Criptonomia.'
                )
              "
            >
              {{ $t('callToAction.express') }}
              <v-icon right dark>
                mdi-whatsapp
              </v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-form class="mt-1">
            <v-text-field
              :label="$t('contactUs.name')"
              v-model="form.name"
              required
              outlined
            ></v-text-field>
            <v-text-field
              :label="$t('contactUs.emailForm')"
              v-model="form.email"
              required
              outlined
            ></v-text-field>
            <v-text-field
              :label="$t('contactUs.company')"
              v-model="form.company"
              required
              outlined
            ></v-text-field>
            <v-text-field
              :label="$t('contactUs.intention')"
              v-model="form.intention"
              required
              outlined
            ></v-text-field>
            <v-btn submit x-large color="primary" min-width="100%" @click="sendMail()">{{
              $t('contactUs.send')
            }}</v-btn>
          </v-form>
        </v-col>
      </v-row>
      <v-responsive max-width="1200" class="mx-auto text-center mt-8">
        <h3 style="color: #001E4A; text-aling: center; font-size: 20px">
          {{ $t('contactUs.asset') }}
        </h3>
      </v-responsive>
    </v-container>
  </v-sheet>
</template>
<script src="https://cdn.jsdelivr.net/npm/axios@0.12.0/dist/axios.min.js"></script>
<script>
import UserController from 'Controllers/user';
export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        company: '',
        intention: '',
      },
    };
  },
  methods: {
    async sendMail() {
      const userController = new UserController();
      try {
        await userController.sendMail(this.form);
        return alert('Agradecemos seu contato!');
      } catch (e) {
        alert('Agradecemos seu contato!');
      }
    },
    openNewTab(obj) {
      window.open(obj);
    },
  },
};
</script>
